<script setup lang="ts">
import { CommonIncidentId } from '@collector/sportsapi-client-legacy'
import PocketIncidentButton from '@desktop/views/Relation/Sports/components/RelationView/Main/PocketIncidents/PocketIncidentButton.vue'
import PocketIncidentsButtons from '@desktop/views/Relation/Sports/components/RelationView/Main/PocketIncidents/PocketIncidentsButtons.vue'
</script>

<template>
  <div class="flex flex-1 justify-end">
    <PocketIncidentsButtons>
      <template #default="{ incidentId, title }">
        <PocketIncidentButton
          v-if="incidentId === CommonIncidentId.TechnicalProblems"
          class="flex flex-col"
          :incidentId
          icon="bolt"
          variant="flat"
        >
          <span class="text-3xs">
            {{ title }}
          </span>
        </PocketIncidentButton>
      </template>
    </PocketIncidentsButtons>
  </div>
</template>
